module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('h1', {
    staticClass: "ui inverted center aligned header"
  }, [_vm._v("Slack Clone")]), _vm._v(" "), _c('connected-user'), _vm._v(" "), _c('div', {
    staticClass: "ui divider"
  }), _vm._v(" "), _c('channels'), _vm._v(" "), _c('div', {
    staticClass: "ui divider"
  }), _vm._v(" "), _c('users')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-383657ff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/Sidebar.vue
// module id = 221
// module chunks = 1